import { Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { RESTOCK_NOTIFICATION_FAILED_IMAGE_URL, RESTOCK_NOTIFICATION_SUCCEEDED_IMAGE_URL } from '../../constant/image';
import { ToastPopup } from './common/ToastPopup';

interface Props {
  status: 'succeeded' | 'failed' | null;
  onClose: () => void;
}
export const RestockNotificationPopup = ({ status, onClose }: Props) => {
  if (status === null) {
    return null;
  }

  return (
    <ToastPopup duration={2000} onClose={onClose}>
      <Container>
        {status === 'succeeded' && (
          <>
            <NotiImage src={RESTOCK_NOTIFICATION_SUCCEEDED_IMAGE_URL} alt='성공 이미지' />
            <Text variant='Body_17_Bold' v3Color='gray900'>
              재입고 알림이 신청되었어요
            </Text>
            <Spacing />
            <Text
              variant='Body_14_Regular'
              v3Color='gray700'
              align='center'
              style={{ wordBreak: 'keep-all', padding: '0 12px' }}
            >
              상품이 재입고되면 카카오톡과 푸시알림으로 빠르게 알려드릴게요.
            </Text>
            <Spacing />
            <Text variant='Caption_12_SemiBold' v3Color='gray400'>
              전화번호가 없는 경우 푸시알림만 수신됩니다.
            </Text>
            <Spacing padding={7} />
          </>
        )}
        {status === 'failed' && (
          <>
            <NotiImage src={RESTOCK_NOTIFICATION_FAILED_IMAGE_URL} alt='실패 이미지' />
            <Text variant='Body_17_Bold' v3Color='gray900'>
              앗, 다시 한번 시도해주세요
            </Text>
            <Spacing />
            <Text variant='Body_14_Regular' v3Color='gray700' align='center'>
              오류가 지속되면 고객센터로 문의해주세요.
            </Text>
            <Spacing padding={2} />
          </>
        )}
      </Container>
    </ToastPopup>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const NotiImage = styled.img`
  width: 75px;
  height: 72px;
  margin-bottom: 24px;
`;

const Spacing = styled.div<{ padding?: number }>`
  padding: ${({ padding }) => `${padding ?? 8}px;`};
`;
